import Container from './HybridActivityTab';
export default Container;

export const componentName = 'HybridActivityTab';
